import { PkceEnvironmentConfig } from '../types';
import { scopes } from './common';

/**
 * PKCE configuration for DEV environment
 * Applies to: devc.blackrock.com, azdevdmz.blackrock.com
 */
export const devConfig: PkceEnvironmentConfig = Object.freeze({
  clientId: process.env.VITE_CLIENT_ID_DEV || '',
  authorizationUrl: process.env.VITE_AGRAPH_EXTERNAL_DEV_URL + '/api/oauth2/DEV/default/v1/authorize',
  tokenUrl: process.env.VITE_AGRAPH_EXTERNAL_DEV_URL + '/api/oauth2/DEV/default/v1/token',
  providerConfiguration: {
    idp: process.env.VITE_IDP_PREPROD,
    type: 'okta' as const,
  },
  scope: scopes.join(' '),
  apiBaseUrl: process.env.VITE_AGRAPH_EXTERNAL_DEV_URL || '',
});
